import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { isConsumer } from 'owa-session-store';
import { isEventAMeeting } from 'owa-calendar-event-capabilities';
import { OwaDate, addDays, isBefore } from 'owa-datetime';

const maxDaysToShowFreeBusy = 28;
const maxAttendeesToShowFreeBusy = 20;

// Returns true if at least one flavor of free busy should be shown (availability row or grid shading)
// According to https://msft.spoppe.com/teams/EXOcd/_layouts/OneNote.aspx?id=%2Fteams%2FEXOcd%2FSiteAssets%2FCalendar%20and%20Devices%20Notebook&wd=target%28PM%2FMeeting%20Form.one%7CEF941341-7EAF-4275-B93D-4B3E83F028BE%2FRules%20for%20showing%20availability%20row%20and%20busy%20shading%7C63EFB65F-1541-432C-8BDC-1DFC59706738%2F%29
export default function shouldShowFreeBusy(event: CalendarEvent) {
    if (isConsumer() || !isEventAMeeting(event)) {
        return false;
    } else {
        const { RequiredAttendees, OptionalAttendees, Resources } = event;
        const resourceCount = Resources ? Resources.length : 0;
        const count = RequiredAttendees.length + OptionalAttendees.length + resourceCount;
        return count <= maxAttendeesToShowFreeBusy;
    }
}

export function getEndTimeToShowFreeBusy(start: OwaDate, end: OwaDate) {
    const maxEnd = addDays(start, maxDaysToShowFreeBusy);
    return isBefore(end, maxEnd) ? end : maxEnd;
}
